// extracted by mini-css-extract-plugin
export default {"Headers":"Header_Headers__XMzJX","Herobutton":"Header_Herobutton__qAX8R"};